export const widgetConfig = {
    hotelId: 'cabothotels',
    ticker: '',
    engine: 'roiback',
    showPrice: false,
    defaultAdults: 2,
    defaultChildren: 0,
    currency: 'EUR',
    baseUrl: 'https://booking.cabot-hotels.com/',
    urlChain: 'bookcore/availability',
    urlHotel: 'bookcore/availability',
    showChildAges: true,
    noOnDesktop: true,
    type: 'chain',
    maxRooms: '4',
    showAllHotelsOption: 'false',
    targetBlank: false,
    maxDate: '2028-01-01',
};
